// extracted by mini-css-extract-plugin
export default {"darkGrey":"#73818a","descriptionContent":"descriptionContent__2UwsT","summary":"summary__o04or","description":"description__365sn","title":"title__30ljP","summaryRow":"summaryRow__UC5r1","chip":"chip__4Tw0C","textContent":"textContent__WqSh8","file":"file__OxPJM","fileIcon":"fileIcon__2IdJD","fileName":"fileName__3R6Gk"};
    if(module.hot) {
      // 1788784382068
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  